var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"H5Container"},[_c('b-container',{staticClass:"WXContainer bottomBorder text-center"},[_vm._t("title")],2),_vm._v(" "),_c('b-container',{staticClass:"WXContainer text-center"},[_vm._t("body")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25660f38","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WEUI/WXContainer.vue
// module id = null
// module chunks = 